export const isDtg = name =>
  name
    ? name.trim().toLowerCase().includes('ricoh ri 1000') ||
      name.trim().toLowerCase().includes('ricoh ri 2000')
    : false;
